module.exports = __webpack_public_path__ + "static/IMG_1241-843ab5bd199dda4814df19f9e5f697d1.jpg";